import { GET_BOOKING_INFO_LOADING, BOOKING_DATA_SUCCESS, BOOKING_DATA_ERROR, GET_MULTIPLE_BOOKINGS_INFO_LOADING } from "../actions/actionBooking";
import { apiBooking, apiBookingIdsValidation } from 'api';
import { put, takeEvery } from 'redux-saga/effects';

async function fetchAsync(func, param) {
    const response = await func(param);

    if (response.ok && response.status == 200) {
        return await response.json();
    }
    else if (response.status == 204) {
        return "nocontent";
    }
    if (response.status == 400) {
        let error = await response.json();

        let url = response.url.match(/[?&]Type=([^&]+)/);
        let type = url ? url[1] : null;

        if (type === "MultipleBookings")
            throw error;
        else
            throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"" + error.Errors[0].ErrorMessage.replace('Error: ', '') + " response status: " + response.status + "\"}]}")
    }
    else {
        throw JSON.parse("{\"Errors\":[{\"ErrorMessage\":\"Unable to get booking details, response status: " + response.status + "\"}]}")
    }
}

function* fetachBooking(action) {
    try {
        const data = yield fetchAsync(apiBooking, action.payload);
        yield put({ type: BOOKING_DATA_SUCCESS, payload: data });
    } catch (e) {
        yield put({ type: BOOKING_DATA_ERROR, error: e.Errors[0].ErrorMessage });
    }
}

function* fetchMultipleBookings(action) {
    try {
        const data = yield fetchAsync(apiBookingIdsValidation, action.payload);
        yield put({ type: BOOKING_DATA_SUCCESS, payload: data });
    } catch (e) {
        yield put({ type: BOOKING_DATA_ERROR, error: e });
    }

}

export const bookingSaga = [
    takeEvery(GET_BOOKING_INFO_LOADING, fetachBooking),
    takeEvery(GET_MULTIPLE_BOOKINGS_INFO_LOADING, fetchMultipleBookings),
];
